export default __webpack_public_path__ + "static/media/spaghettis-bolognaise_istock.b307cd7e.jpg";